<mat-toolbar color="primary">
  <span>Fleet Management</span>
</mat-toolbar>

<mat-card *ngFor="let vehicle of vehicles;let vehicleIndex = index;">
  <mat-card-header>
    <div mat-card-avatar class="example-header-image"></div>
    <mat-card-title>{{vehicle.vin}} <button mat-button color="warn" (click)="changeFleet(false, vehicle.vin)" [disabled]="posting">Remove Vehicle</button></mat-card-title>
    <mat-card-subtitle>{{vehicle.p2p ? "P2P vehicle" : "Fleet vehicle"}}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
      <mat-expansion-panel [(expanded)]="expansions[''+vehicleIndex]">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Capabilities
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div *ngIf="vehicle.capabilities == null || vehicle.capabilities.length === 0">
          No Capabilities
        </div>
        <div *ngFor="let capability of vehicle.capabilities;let capabilityIndex = index;">
          <mat-expansion-panel [(expanded)]="expansions[''+vehicleIndex+'-'+capabilityIndex]">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-chip-list>
                  <mat-chip color="primary" selected>{{capability.label}} = {{capability.value}}</mat-chip>
                  <button mat-icon-button color="warn" (click)="removeCapability(vehicleIndex, capabilityIndex)" [disabled]="posting">
                    <mat-icon>delete</mat-icon>
                  </button>
                </mat-chip-list>
              </mat-panel-title>
              <mat-panel-description>
                Click to expand/contract contexts
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div *ngIf="capability['contexts'] == null || capability['contexts'].length === 0">
              No Contexts
            </div>
            <mat-chip-list *ngFor="let context of capability['contexts'];let contextIndex = index;">
              <mat-chip color="accent" style="margin-left: 20px" selected>{{context.label}} = {{context.value}}</mat-chip>
              <button mat-icon-button color="warn" (click)="removeContext(vehicleIndex, capabilityIndex, contextIndex)" [disabled]="posting">
                <mat-icon>delete</mat-icon>
              </button>
            </mat-chip-list>
            <mat-form-field>
              <mat-label>New Context Name</mat-label>
              <input matInput type="text" [(ngModel)]="newContextFields[vehicleIndex][capabilityIndex].name">
            </mat-form-field>
            &nbsp;&nbsp;&nbsp;
            <mat-form-field>
              <mat-label>New Context Value</mat-label>
              <input matInput type="text" [(ngModel)]="newContextFields[vehicleIndex][capabilityIndex].value">
            </mat-form-field>
            <button mat-icon-button color="primary" (click)="addContext(vehicleIndex, capabilityIndex)" [disabled]="posting">
              <mat-icon>add</mat-icon>
            </button>
          </mat-expansion-panel>
        </div>
        <mat-form-field>
          <mat-label>New Capability Name</mat-label>
          <input matInput type="text" [(ngModel)]="newCapabilityFields[vehicleIndex].name">
        </mat-form-field>
        &nbsp;&nbsp;&nbsp;
        <mat-form-field>
          <mat-label>New Capability Value</mat-label>
          <input matInput type="text" [(ngModel)]="newCapabilityFields[vehicleIndex].value">
        </mat-form-field>
        <button mat-icon-button color="primary" (click)="addCapability(vehicleIndex)" [disabled]="posting">
          <mat-icon>add</mat-icon>
        </button>
      </mat-expansion-panel>
      <mat-expansion-panel [(expanded)]="expansions['profiles'+vehicleIndex]">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Profiles
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div *ngIf="vehicle.profiles == null || vehicle.profiles.length === 0">
          No Profiles
        </div>
        <mat-chip-list *ngFor="let profile of vehicle.profiles;let profileIndex = index;">
          <mat-chip>{{profile.label}}</mat-chip>
          <button mat-icon-button color="primary" (click)="editProfile(vehicleIndex, profileIndex)" [disabled]="posting">
            <mat-icon>edit</mat-icon>
          </button>
        </mat-chip-list>
        <mat-form-field>
          <mat-label>New Profile Name</mat-label>
          <input matInput type="text" [(ngModel)]="newProfileFields[vehicleIndex].name">
        </mat-form-field>
        <button mat-icon-button color="primary" (click)="editProfile(vehicleIndex, null)" [disabled]="posting">
          <mat-icon>add</mat-icon>
        </button>
      </mat-expansion-panel>
  </mat-card-content>
</mat-card>

<mat-form-field style="margin-left: 20px">
  <mat-label>New Vehicle VIN</mat-label>
  <input matInput type="text" [(ngModel)]="newVehicleInput">
</mat-form-field>
<button mat-icon-button color="primary" (click)="changeFleet(true, newVehicleInput)" [disabled]="posting">
  <mat-icon>add</mat-icon>
</button>
